import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import Services from "./components/Services/Services";
import WhyChooseUs from "./components/WhyChooseUs";
import Partners from "./components/Partners";
import Loans from "./components/Loans";
import Insurance from "./components/Insurance";
import Thawa from "./components/Thawa";
import RealEstate from "./components/RealEstate";
import Testimonials from "./components/Testimonials/Testimonials";
import FAQ from "./components/FAQ/FAQ";
import CTA from "./components/CTA";
import About from "./components/About";
import Contact from "./components/Contact";
import Footer from "./components/Footer";
import ScrollToTop from "./components/ScrollToTop";
import { Helmet } from "react-helmet-async";

// Home page component (without Loans, Insurance, Thawa, Real Estate)
function Home() {
  return (
    <>
    <Helmet>
        <title>Pollachi Wealth Care - Loans & Financial Services</title>
        <meta
          name="description"
          content="Explore personal, home, car, education, and business loans in Pollachi. Flexible repayment and trusted financial services."
        />
        <meta name="keywords" content="Pollachi loans, personal loan, home loan, car loan, business loan, financial services" />
        <meta name="author" content="Pollachi Wealth Care" />

        {/* Open Graph / Social Sharing */}
        <meta property="og:title" content="Pollachi Wealth Care - Loans & Financial Services" />
        <meta property="og:description" content="Explore personal, home, car, education, and business loans in Pollachi." />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://fin-nest-pollachi.vercel.app/loans" />
        <meta property="og:image" content="https://fin-nest-pollachi.vercel.app/og-image.png" />

        {/* Twitter Card */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Pollachi Wealth Care - Loans & Financial Services" />
        <meta name="twitter:description" content="Explore personal, home, car, education, and business loans in Pollachi." />
        <meta name="twitter:image" content="https://fin-nest-pollachi.vercel.app/og-image.png" />
      </Helmet>
    <main>
      <Hero />
      <Services />
      <WhyChooseUs />
      <Partners />
      <Testimonials />
      <FAQ />
      <CTA />
    </main>
    </>
  );
}

function App() {
  return (
    <Router>
      <ScrollToTop />
      <div className="min-h-screen bg-white text-gray-900">
        <Navbar />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/loans" element={<Loans />} />
          <Route path="/insurance" element={<Insurance />} />
          <Route path="/thawa" element={<Thawa />} />
          <Route path="/realestate" element={<RealEstate />} />
          <Route path="/about" element={<About />} />
          <Route path="/contact" element={<Contact />} />
        </Routes>
        <Footer />
      </div>
    </Router>
  );
}

export default App;
